<!-- Tiêu Đề Trang -->

<div style="margin-left: 5px; height: 80%; width: 96%" class="disabled-scroll">
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-calendar-alt mr-2"></i>{{ menu?.calendarI18n }}
  </h1>
  
  <!-- Mô Tả Dưới Tiêu Đề -->
  <p class="lead mb-4">
    Xem và quản lý các sự kiện trên lịch của bạn. Sử dụng giao diện lịch để chọn ngày, thêm sự kiện mới và xem các hoạt động đã lên lịch. Tùy chỉnh chế độ xem lịch theo nhu cầu của bạn.
  </p>
  <ngx-event-calendar
    [showAddButton]="false"
    [language]="'vi'"
    [dataSource]="dataArray"
    (dayEvents)="selectDay($event)"
    (newEvent)="addEvent($event)"
  >
  </ngx-event-calendar>
</div>
